const socialsList = [
  {
    title: "Facebook",
    link: "https://www.facebook.com/motilaloswalamc",
    image: "/mutualfund/assets/images/footer/facebook.png"
  },
  {
    title: "Instagram",
    link: "https://www.instagram.com/motilaloswalamc",
    image: "/mutualfund/assets/images/footer/instagram.png"
  },
  {
    title: "X",
    link: "https://twitter.com/MotilalOswalAMC",
    image: "/mutualfund/assets/images/footer/x.png"
  },
  {
    title: "Youtube",
    link: "https://youtube.com/motilaloswalamc",
    image: "/mutualfund/assets/images/footer/youtube.png"
  },
  {
    title: "Linkedin",
    link: "https://www.linkedin.com/company/motilal-oswal-amc",
    image: "/mutualfund/assets/images/footer/linkedin.png"
  },
]

const appLinksList = [
  {
    title: "Apple Appstore",
    link: "https://apps.apple.com/in/app/motilal-oswal-mf-pms/id6463774883",
    image: "/mutualfund/assets/images/footer/appstore.svg",
    width: 120
  },
  {
    title: "Google Play",
    link: "https://play.google.com/store/apps/details?id=com.moamc.investorapp&hl=en_IN&gl=US",
    image: "/mutualfund/assets/images/footer/playstore.svg",
    width: 135
  }
]

const appLinksListMobile = [
  {
    title: "Apple Appstore",
    link: "https://apps.apple.com/in/app/motilal-oswal-mf-pms/id6463774883",
    image: "/mutualfund/assets/images/footer/appstore_mobile.png",
    width: 120
  },
  {
    title: "Google Play",
    link: "https://play.google.com/store/apps/details?id=com.moamc.investorapp&hl=en_IN&gl=US",
    image: "/mutualfund/assets/images/footer/playstore_mobile.png",
    width: 135
  }
]

const copyrightLinks = [
  {
    title: "Scores Portal",
    link: "https://scores.sebi.gov.in/",
    external: true,
  },
  {
    title: "Smart ODR",
    link: `https://smartodr.in/login`,
    external: true,
  },
  {
    title: "Disclaimer",
    link: `/disclaimer`
  },
  {
    title: "Voting Policies",
    link: `/assets/pdf/voting-policy.pdf`,
    external: true,
  },
  {
    title: "Privacy Policy",
    link: `/privacy-policy`
  },
  {
    title: "Terms and Conditions",
    link: `/privacy-policy`
  },
  {
    title: "Sitemap",
    link: `/sitemap`
  },
]

const footerLinks = {
  "Mutual Fund": [
    {
      title: "Indian Equity Funds",
      link: `/mutual-funds/category/indian-equity`
    },
    {
      title: "International Equity Funds",
      link: `/mutual-funds/category/international-equity`
    },
    {
      title: "Hybrid & Balanced Funds",
      link: `/mutual-funds/category/hybrid-balanced`
    },
    {
      title: "Multi Asset Funds",
      link: `/mutual-funds/category/multi-asset`
    },
    {
      title: "Commodity Funds",
      link: `/mutual-funds/category/commodity`
    },
    {
      title: "Debt & Liquid Funds",
      link: `/mutual-funds/category/debt-liquid`
    },
    {
      title: "Index Funds",
      link: `/index-fund`
    },
    {
      title: "ETFs",
      link: `/etf`
    }
  ],
  "Services": [
    {
      title: "Request Reports/Statement",
      link: "/mutualfund/login?returnUrl=/reports/account-statement"
    },
    {
      title: "Add Bank Mandate",
      link: "/mutualfund/login?returnUrl=/manage-account/emandate"
    },
    {
      title: "Add Nominee",
      link: "/mutualfund/login?returnUrl=/manage-account/nomineemanage"
    },
    {
      title: "Update KYC",
      link: `/modify-kyc`
    },
    {
      title: "Unclaimed Redemption / IDCW",
      link: `/mutualfund/unclaimed/login`
    },
    {
      title: "Start SIP",
      link: `/sip`
    },
    {
      title: "MITRA",
      link: "https://app.mfcentral.com/links/inactive-folios",
      external: true,
    },
  ],
  "Tools": [
    {
      title: "SIP Returns Calculator",
      link: `/sip-calculator`
    },
    {
      title: "Compare Portfolio",
      link: `/tools/compare-portfolio`
    },
    {
      title: "Compounding Magic",
      link: `/tools/compounding-magic`
    }
  ],
  "Group Websites": [
    {
      title: "Financial Services",
      link: "https://www.motilaloswalgroup.com/",
      external: true,
    },
    {
      title: "Broking & Distribution",
      link: "https://www.motilaloswal.com/",
      external: true,
    },
    {
      title: "Private Wealth Management",
      link: "https://www.motilaloswalpwm.com/",
      external: true,
    },
    {
      title: "Home Finance",
      link: "https://motilaloswalhf.com/",
      external: true,
    },
    {
      title: "Institutional Equities",
      link: "https://www.motilaloswalgroup.com/Our-Businesses/Institutional-Equities",
      external: true,
    },
    {
      title: "Private Equity",
      link: "https://www.motilaloswalalt.com/",
      external: true,
    },
    {
      title: "Investment Banking",
      link: "https://www.motilaloswalgroup.com/Our-Businesses/Investment-Banking",
      external: true,
    },
  ],
  "Quick Links": [
    {
      title: "About Us",
      link: `/about-us/overview`
    },
    {
      title: "Contact Us",
      link: `/contact-us`
    },
    {
      title: "Investor Charter",
      link: `${process.env.REACT_APP_MOTILAL_MF_MODULE_URL}CMS/assets/uploads/files/MF-Investor-Charter.pdf`,
      external: true
    },
    {
      title: "FAQs",
      link: `${process.env.REACT_APP_PARTNER_MODULE_URL}faq`,
    }
  ],
  "Planning & Solutions": [
    {
      title: "FAB",
      link: "/fabplan"
    },
    {
      title: "MOVI Plan",
      link: "/motilal-oswal-value-index"
    },
    {
      title: "SIP",
      link: "/sip"
    },
  ]
}

export {
  appLinksList,
  appLinksListMobile,
  copyrightLinks,
  socialsList,
  footerLinks,
}

